// Point this at your production domain once deployed.
// Apache2 proxies /api → http://127.0.0.1:5000/
export const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';
